import styled from 'styled-components';

const Text = styled.span`
  font-size: 15px;
  color: #6e7277;
  width: 180px;
`;

export default Text;
